import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Row, Col, Button, OverlayTrigger, Tooltip, Container } from 'react-bootstrap';
import AddCircle from 'mdi-react/AddCircleIcon';
import { useFormikContext } from 'formik';

import history from 'browserHistory';
import TopBorderBtn from 'modules/shared/TopBorderBtn';
import { useModal } from 'modules/shared/hooks';
import YesNoModal from 'modules/shared/YesNoModal';
import styles from 'modules/shared/FlightTop/FlightTop.module.scss';
import { setTab } from 'modules/common/Tabs/actions';
import { clearBranchState } from 'modules/admin/containers/BranchEditing/actions';
import { settingsGlobSelector } from 'modules/admin/containers/SettingsContainer/selectors';
import { saveGlobalSet } from 'modules/admin/containers/SettingsContainer/actions';
import { branchSelector } from 'modules/admin/containers/BranchEditing/selectors';

type Props = {
  title: string;
  branchId?: number;
  onSave?: () => void;
  onClose?: () => void;
  onDelete?: () => void;
};

const AdminTop: React.FC<Props> = ({ title, onClose, onSave, onDelete }) => {
  const formik = useFormikContext() || {};
  const { isValid } = formik;

  const dispatch = useDispatch();
  const path = history.location.pathname.split('/');
  const isBranch = path.includes('branch');
  const isSettings = path.includes('settings');
  const isMainPage = path.length === 2;

  const { forceSaveSet } = useSelector(settingsGlobSelector);
  const { branchForceSave } = useSelector(branchSelector);

  const { isShow, closeModal, openModal } = useModal();
  const { isShow: isShowCloseTab, openModal: openCloseTab, closeModal: closeCloseTab } = useModal();

  const handleCreateBranch = () => {
    history.push('/globaladmin/branch/create');
    dispatch(clearBranchState());

    dispatch(
      setTab({
        id: `branch_create`,
        href: `/globaladmin/branch/create`,
        title: `Cтровення філії`,
        closeRedirectPath: '/globaladmin',
      }),
    );
  };

  const closeSaveHandler = () => {
    if (!isValid && onSave) {
      closeCloseTab();
      return onSave();
    }
    if (onSave) onSave();
    if (onClose) onClose();
    closeCloseTab();
  };

  useEffect(() => {
    if (forceSaveSet && onSave) onSave();
  }, [forceSaveSet]);

  useEffect(() => {
    if (branchForceSave && onSave) onSave();
  }, [branchForceSave]);

  useEffect(() => {
    if (formik && formik.touched && Object.keys(formik.touched).length) {
      dispatch(saveGlobalSet(false));
    }
  }, [formik?.touched]);

  return (
    <Container className="d-flex flex-row justify-content-between align-items-center mb-3 px-5 mx-3">
      <h3 className="text-center font-weight-bolder m-0">{title}</h3>
      <Form.Group as={Row} className="position-relative mb-0">
        {isMainPage && (
          <Col className={styles.bts}>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Створити філію</Tooltip>}>
              <Button variant="light" className="p-0 bg-transparent border-0" onClick={handleCreateBranch}>
                <AddCircle size={30} className="text-success" />
              </Button>
            </OverlayTrigger>
          </Col>
        )}

        {isBranch && (
          <Col className="d-flex justify-content-end">
            <TopBorderBtn icon="delete" clickHandler={openModal} tooltip="Видалити філію" />
            <TopBorderBtn
              icon="save"
              clickHandler={() => {
                if (onSave) onSave();
              }}
            />
            <TopBorderBtn icon="close" clickHandler={openCloseTab} />
          </Col>
        )}

        {isSettings && (
          <Col className="d-flex justify-content-end">
            <TopBorderBtn
              icon="save"
              clickHandler={() => {
                if (onSave) onSave();
              }}
            />
          </Col>
        )}
      </Form.Group>

      <YesNoModal
        isShow={isShow}
        title="Видалити філію"
        closeModal={closeModal}
        acceptHandler={() => {
          if (onDelete) onDelete();
        }}
      />

      <YesNoModal
        isShow={isShowCloseTab}
        title="Бажаєте зберегти зміни"
        closeHandler={closeCloseTab}
        acceptHandler={closeSaveHandler}
        closeModal={() => {
          closeCloseTab();
          if (onClose) onClose();
        }}
      />
    </Container>
  );
};

export default AdminTop;
